import React from "react";
import { EmployeeStatutoryKYCinfo } from "./statutory-kyc-service";
import StatutoryKycView from "./statutory-kyc-view";
import StatutoryKycCreate from "./statutory-kyc-create";




const EmployeeStatutoryKyc = () => {

  const {
    orginfo,
    orginfoESCI,
    fileInputRef,
    EmployeeESCI,
    onChnageESCI,
    OnBlureESCI,
    ToggleEsci,
    errorsESCI,
    EmployeeEPF,
    onChanageEPF,
    OnBlureEPF,
    ToggleEPF,
    errorsEPF,
    bankdetails,
    onChangeBank,
    // OnBlureBank,
    errorBank,
    handleButtonClick,
    handleFileChange,
    docs,
    alldocs,
    checkDocName,
    DeleteSpecificFile,
    onChangeKYCdoc,
    openFileInNewTab,
    SubmitData,
    UpdateStatutory,
    employeeInfo,
    escimodal, TogggleEsciMOdal,
    epfmodal,
    TogggleEpfMOdal,
    bankmodal,
    ToggleBank,
    kycModal,
    ToggleKycModal,
    updateLoder
  } = EmployeeStatutoryKYCinfo();

  return (
    <>
      {
        employeeInfo?.statusCode === 200 ?
          <>
            <StatutoryKycView
              orginfo={orginfo}
              orginfoESCI={orginfoESCI}
              fileInputRef={fileInputRef}
              EmployeeESCI={EmployeeESCI}
              onChnageESCI={onChnageESCI}
              OnBlureESCI={OnBlureESCI}
              ToggleEsci={ToggleEsci}
              errorsESCI={errorsESCI}
              EmployeeEPF={EmployeeEPF}
              onChanageEPF={onChanageEPF}
              OnBlureEPF={OnBlureEPF}
              ToggleEPF={ToggleEPF}
              errorsEPF={errorsEPF}
              bankdetails={bankdetails}
              onChangeBank={onChangeBank}
              // OnBlureBank={OnBlureBank}
              errorBank={errorBank}
              handleButtonClick={handleButtonClick}
              handleFileChange={handleFileChange}
              docs={docs}
              alldocs={alldocs}
              checkDocName={checkDocName}
              DeleteSpecificFile={DeleteSpecificFile}
              onChangeKYCdoc={onChangeKYCdoc}
              openFileInNewTab={openFileInNewTab}
              UpdateStatutory={UpdateStatutory}
              employeeInfo={employeeInfo?.data}
              escimodal={escimodal}
              TogggleEsciMOdal={TogggleEsciMOdal}
              epfmodal={epfmodal}
              TogggleEpfMOdal={TogggleEpfMOdal}
              bankmodal={bankmodal}
              ToggleBank={ToggleBank}
              kycModal={kycModal}
              ToggleKycModal={ToggleKycModal}
              updateLoder={updateLoder}
            />
          </> :
          <>
            <StatutoryKycCreate
              orginfo={orginfo}
              orginfoESCI={orginfoESCI}
              fileInputRef={fileInputRef}
              EmployeeESCI={EmployeeESCI}
              onChnageESCI={onChnageESCI}
              OnBlureESCI={OnBlureESCI}
              ToggleEsci={ToggleEsci}
              errorsESCI={errorsESCI}
              EmployeeEPF={EmployeeEPF}
              onChanageEPF={onChanageEPF}
              OnBlureEPF={OnBlureEPF}
              ToggleEPF={ToggleEPF}
              errorsEPF={errorsEPF}
              bankdetails={bankdetails}
              onChangeBank={onChangeBank}
              // OnBlureBank={OnBlureBank}
              errorBank={errorBank}
              handleButtonClick={handleButtonClick}
              handleFileChange={handleFileChange}
              docs={docs}
              alldocs={alldocs}
              checkDocName={checkDocName}
              DeleteSpecificFile={DeleteSpecificFile}
              onChangeKYCdoc={onChangeKYCdoc}
              openFileInNewTab={openFileInNewTab}
              SubmitData={SubmitData}
              employeeInfo={employeeInfo?.data}
            />
          </>
      }

    </>



  );
};

export default EmployeeStatutoryKyc;
